@if (configuration$ | async; as config) {
  <section class="sh-dashboard-content-template__row">
    <div class="sh-dashboard-panel">
      <digihaven-dashboard-title
        [title]="config.title"
        [icon]="'inbox'"
        [navigationLink]="taskListNavigation"
        [totalItems]="totalTaskCount$ | async"
      ></digihaven-dashboard-title>
      <div class="sh-data-table-wrapper">
        <table class="sh-data-table">
          <thead>
            <tr>
              <th scope="col" width="10%">{{ config.DueDate.title }}</th>
              <th scope="col" width="50%">{{ config.Record.title }}</th>
              <th scope="col" width="40%">{{ config.Task.title }}</th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading) {
              <tr>
                <td colspan="3">{{ config.loading }}</td>
              </tr>
            }
            @if (hasError) {
              <tr>
                <td colspan="3">{{ config.error }}</td>
              </tr>
            }
            @if (tasks && tasks.length === 0) {
              <tr>
                <td colspan="3">{{ config.noResults }}</td>
              </tr>
            }
            @if (tasks && tasks.length > 0) {
              @for (task of tasks; track task; let i = $index) {
                <tr>
                  @if (task.DueDate) {
                    <td>{{ task.DueDate | readableDate }}</td>
                  } @else {
                    <td>-</td>
                  }
                  <th scope="row">
                    <a class="sh-link" [shNavigationLink]="getNavigationLink(i)">{{ task.Subject?.Content.Name || "-" }}</a>
                  </th>
                  <td>{{ task.TaskInfo.Name }}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </section>
}
